

export class SolicitudAtestFitoLugarProduccionViewModel {

    constructor() {

    }

    public Id: number;
    public IdEstado: number = 0;
    public IdEstadoDescripcion: string;
    public IdTipoSolicitud: number = 0;
    public IdTipoSolicitudDescripcion: string;
    public CodigoTipoSolicitud: string;
    public RefAtestFito: string;
    public IdComunidadAutonoma: number;
    public TwParcelasAtestFitoCollection: TwParcelasAtestFitoViewModel[];
    public TwViveroAtestFito: TwViveroAtestFitoViewModel;
    public TwAlmacenConfeccionAtestFito: TwAlmacenConfeccionAtestFitoViewModel;
    public TwOtroLugarProduccionAtestFito: TwOtroLugarProduccionAtestFitoViewModel;
}

export class TwParcelasAtestFitoViewModel {
    public Id: number;
    public IdSolicitudAtestFito: number;
    public CodigoSigPac: string;
    public SuperficieSigPac: number;
    public UsoSigPac: string;
    public IdProvinciaParcela: number;
    public IdMunicipioParcela: number | null;
    public DireccionParcela: string;
    public ProvinciaParcelaDescripcion: string;
    public MunicipioParcelaDescripcion: string;
}

export class TwViveroAtestFitoViewModel {
    public IdSolicitudAtestFito: number;
    public RazonSocialVivero: string;
    public DireccionVivero: string;
    public IdProvinciaVivero: number | null;
    public IdMunicipioVivero: number | null;
    public CodigoPostalVivero: string;
}

export class TwAlmacenConfeccionAtestFitoViewModel {
    public IdSolicitudAtestFito: number;
    public NumRgseaa: string;
    public RazonSocialAlmacen: string;
    public DireccionAlmacen: string;
    public IdProvinciaAlmacen: number | null;
    public IdMunicipioAlmacen: number | null;
    public CodigoPostalAlmacen: string;
}

export class TwOtroLugarProduccionAtestFitoViewModel {
    public IdSolicitudAtestFito: number;
    public RazonSocialOtroLugar: string;
    public DireccionOtroLugar: string;
    public IdProvinciaOtroLugar: number | null;
    public IdMunicipioOtroLugar: number | null;
    public CodigoPostalOtroLugar: string;
}

export class RecintoInfoRequestViewModel {
    public Provincia: string;
    public Municipio: string;
    public Agregado: string;
    public Zona: string;
    public Poligono: string;
    public Parcela: string;
    public Recinto: string;
}

export class ParcelaSimplifVerificadaSigpacViewModel {
    public Superficie: number;
    public Uso_sigpac: string;
}
